import { Badge } from '@radix-ui/themes';
import { MetricHelper } from 'classes/helpers/metric.helper';
import { MachineContext } from 'contexts/machine.context';
import { TrajHelper } from 'lib_ts/classes/trajectory.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ITrajectory } from 'lib_ts/interfaces/pitches';
import { useContext } from 'react';

export const CommonSpeedBadge = (props: { traj: ITrajectory }) => {
  const { machine, unitFactors } = useContext(MachineContext);

  const speedMPH = TrajHelper.getSpeedFromTraj(props.traj);
  const speedDisplay = speedMPH * unitFactors.fromSpeedMph;
  const unitsDisplay = MetricHelper.getSpeedUnit(machine.isMetric, true);

  return (
    <Badge color={RADIX.COLOR.NEUTRAL}>
      {speedDisplay.toFixed(1)}
      <span className="BadgeUnits">{unitsDisplay}</span>
    </Badge>
  );
};
